module.exports = __webpack_public_path__ + "static/img/home2.8978a0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home2.jpg
// module id = zMzR
// module chunks = 1